import { Button } from "@mui/material";

interface ButtonProps {
  title: string;
  onAction: React.MouseEventHandler<HTMLButtonElement> | undefined;
}
const ButtonOutline = ({ title, onAction }: ButtonProps) => {
  return (
    <Button
      variant="outlined"
      sx={{
        width: "100%",
        color: "black",
        border: "1px solid black",
        "&:hover": {
          backgroundColor: "transparent",
          borderColor: "black",
          color: "black",
        },
      }}
      onClick={onAction}
    >
      {title}
    </Button>
  );
};

export default ButtonOutline;
